import { FC, useEffect, useState } from "react";
import { InputNumber, Col, Form, Input, Tooltip } from "antd";
import { useTranslation } from "react-i18next";

import { CreateNumWrap, TitleWrap } from "@/pages/Requirement/style";
import ProductDesc from "@/components/Desc/ProductDesc";
import { SaleItemState } from "@/types/sales";
import SText from "@/styles/SText";
import { plus } from "@/utils/calc";
import { numFormmater } from "@/pages/Requirement/util";

interface CreateHeaderProps {
  current: number;
  requirementCount: number;
  setRequirementCount: (num: number) => void;
  item: SaleItemState;
}

const CreateHeader: FC<CreateHeaderProps> = ({
  item, current, requirementCount, setRequirementCount
}) => {
  const { t } = useTranslation();
  const [list, setList] = useState<{ title: string, value: string | undefined, name: string }[]>([])
  useEffect(() => {
    const arr = [
      { title: t("product.code"), value: item?.product?.code, name: "code" },
      { title: t("product.name"), value: item?.product?.name, name: "name" },
      { title: t("product.uom"), value: item?.product?.uom, name: "uom" },
      { title: t("product.cbm"), value: item?.product?.cbm, name: "cbm" },
      { title: t("product.brand1"), value: item?.product?.model, name: "brand1" },
      { title: t("product.brand2"), value: item?.product?.t1, name: "t1" },
      { title: t("product.process"), value: item?.product?.process, name: "process" },
      { title: t("category.hsCode"), value: item?.product?.hsCode, name: "hsCode" },
      { title: t("common.desc"), value: item?.product?.desc, name: "desc" },
      { title: t("requirement.saleNum"), value: plus((item?.quantity || 0).toString(), (item?.bquantity || 0).toString()), name: "saleNum" },
      // {title: t("requirement.prNum"), value: requirementCount.toString(), name: "prNum"},
    ]
    setList(arr)
  }, [item])
  // const otherItems = [
  //   {
  //     key: "saleNum",
  //     label: t("requirement.saleNum"),
  //     children: plus((item?.quantity || 0).toString(), (item?.bquantity || 0).toString())
  //   },
  // ]

  // if (current > 1) {
  //   otherItems.push({
  //     key: "requirementNum",
  //     label: t("requirement.prNum"),
  //     children: requirementCount.toString()
  //   },)
  // }

  return (
    <TitleWrap>
      <div className="requirement--title">{t("requirement.mainInfo")}</div>
      {/* <ProductDesc product={item.product} otherItems={otherItems} /> */}
      <div style={{
        display: 'flex',
        gap: '50px 50px',
        flexWrap: 'wrap',
        alignContent: 'flex-start',
        alignItems: 'flex-start',
        rowGap: '8px'
      }}>
        {
          list.map(item => {
            return (
              <div>
                <div >
                  <span style={{ color: 'rgba(0, 0, 0, 0.45)' }}>{item.title}: </span>
                  <SText style={{ display: 'inline' }} text={item.value || ''} />
                </div>
              </div>
            )
          })
        }
        {
          current > 1 && (
            <div >
              <span style={{ color: 'rgba(0, 0, 0, 0.45)' }}>{t("requirement.prNum")}: </span>
              <SText style={{ display: 'inline' }} text={requirementCount.toString()} />
            </div>
            // <Col xxl={3} xl={4} lg={8} md={8} sm={12} xs={24}>
            //   <Form.Item label={t("requirement.prNum")} name="prNum" initialValue={requirementCount.toString()}>
            //     <Input disabled/>
            //   </Form.Item>
            // </Col>
          )
        }
      </div>
      {current === 1 && <CreateNumWrap>
        <span>{t('requirement.prNum')}: </span>
        <InputNumber changeOnWheel
          onChange={e => {
            e && setRequirementCount(e)
          }}
          value={requirementCount}
          placeholder={t('requirement.plPrNum')}
          formatter={val => numFormmater(Number(val || 0))}
        />
      </CreateNumWrap>}
    </TitleWrap>
  );
};

export default CreateHeader;
